import * as React from 'react';
import PropTypes from 'prop-types';

export const Corporate = ({ width, height, ...props }) => (
  <svg
    data-icon='corporate'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M5 17v-7h2v7H5Zm6 0v-7h2v7h-2Zm-9 4v-2h20v2H2Zm15-4v-7h2v7h-2ZM2 8V6l10-5 10 5v2H2Zm4.45-2h11.1L12 3.25 6.45 6Z'
    />
  </svg>
);

Corporate.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Corporate.defaultProps = {
  width: 24,
  height: 24,
};
